import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { appsUtil } from "../../../../utils";

export const useMarketLocalizations = (market) => {
  const selectedApp = useSelector((store) => store.apps?.selectedApp);
  const [marketLocalizations, setMarketLocalizations] = useState([]);

  const availableLanguages = appsUtil.getAvailableLanguages();

  useEffect(() => {
    if (market) {
      const newMarketLocalizations = (
        (selectedApp?.marketLocalizations?.find((el) => el.market === market) ?? {})?.languages ??
        []
      ).filter((l) => availableLanguages.includes(l?.name));
      setMarketLocalizations(newMarketLocalizations);
    }
  }, [selectedApp, market]);

  return marketLocalizations ?? [];
};
